const variants = {
  success: 'bg-green-50 border-green-200 text-green-700',
  active: 'bg-green-50 border-green-200 text-green-700',
  warning: 'bg-amber-50 border-amber-200 text-amber-700',
  pending: 'bg-amber-50 border-amber-200 text-amber-700',
  error: 'bg-red-50 border-red-200 text-red-700',
  expired: 'bg-red-50 border-red-200 text-red-700',
  default: 'bg-gray-50 border-gray-200 text-gray-600',
  info: 'bg-blue-50 border-blue-200 text-blue-700',
  primary: 'bg-primary/10 border-primary/20 text-primary',
  sent: 'bg-blue-50 border-blue-200 text-blue-700',
  signed: 'bg-green-50 border-green-200 text-green-700',
  secondary: 'bg-purple-50 border-purple-200 text-purple-700',
};

const Badge = ({ children, variant = 'default', className = '', ...props }) => (
  <span className={`inline-flex px-3 py-1.5 rounded-full text-xs font-medium border ${variants[variant] || variants.default} ${className}`} {...props}>
    {children}
  </span>
);

export default Badge;
